function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#596168",
  fillRule: "evenodd",
  d: "M10.5 10a1.5 1.5 0 011.5 1.5v1a1.5 1.5 0 01-1.5 1.5h-9A1.5 1.5 0 010 12.5v-1A1.5 1.5 0 011.5 10h9zm-2 1h-6a.5.5 0 100 1h6a.5.5 0 100-1zm2-11A1.5 1.5 0 0112 1.5v5A1.5 1.5 0 0110.5 8h-9A1.5 1.5 0 010 6.5v-5A1.5 1.5 0 011.5 0h9zm-4 4h-4a.5.5 0 000 1h4a.5.5 0 000-1zm3-2h-7a.5.5 0 000 1h7a.5.5 0 100-1z"
});

var SvgSegment = function SvgSegment(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14"
  }, props), _ref);
};

export default SvgSegment;